import { Component, EventEmitter, Output } from '@angular/core';
import { ArrivalStatus } from 'src/app/data/models/enum/arrival/arrival-status.enum';
import { GatesMonitoringFilterType } from './gate-monitoring-filter-type';

@Component({
  selector: 'app-gate-monitoring-filter',
  templateUrl: './gate-monitoring-filter.component.html',
  styleUrls: ['./gate-monitoring-filter.component.scss'],
})
export class GateMonitoringFilterComponent {
  @Output() filterType = new EventEmitter<string>();

  filtersType: GatesMonitoringFilterType[] = [
    {
      description: 'A caminho',
      filter: ArrivalStatus.GOING,
      selected: true,
      dirty: false,
    },
    {
      description: 'Autorização',
      filter: 'AUTHORIZED',
      selected: false,
      dirty: false,
    },
    {
      description: 'Imprevisto',
      filter: ArrivalStatus.UNPREDICTABLE,
      selected: false,
      dirty: false,
    },
    {
      description: 'Já Chegou',
      filter: ArrivalStatus.ARRIVED,
      selected: false,
      dirty: false,
    },
    {
      description: 'Histórico',
      filter: 'HISTORY',
      selected: false,
      dirty: false,
    },
  ];

  constructor() {}

  filterClicked(item: any) {
    this.clearSelected();
    this.filtersType[item.index].dirty = false;
    this.filtersType[item.index].selected = true;
    this.emitType(item.index);
  }

  emitType(index: number) {
    let filter = '';
    switch (index) {
      case 0:
        filter = ArrivalStatus.GOING;
        break;
      case 1:
        filter = 'AUTHORIZED';
        break;
      case 2:
        filter = ArrivalStatus.UNPREDICTABLE;
        break;
      case 3:
        filter = ArrivalStatus.ARRIVED;
        break;
      case 4:
        filter = 'HISTORY';
        break;
      default:
        filter = '';
    }
    this.filterType.emit(filter);
  }

  private clearSelected() {
    this.filtersType.forEach((elem) => (elem.selected = false));
  }
}
